<template>
	<div id="cookie-policy">
		<!-- OneTrust Cookies List start -->
		<div id="ot-sdk-cookie-policy"></div>
		<!-- OneTrust Cookies List end -->
	</div>
</template>

<script>
export default {
	name: 'CookiePolicy',
	components: {},
	data() {
		return {};
	},
	computed: {},
	methods: {},
};
</script>
<style lang="less" scoped>
#cookie-policy {
	min-height: 500px;
	padding: 75px 20px 0;
	:deep(#ot-sdk-cookie-policy-v2.ot-sdk-cookie-policy) {
		font-size: 16px;
	}
	:deep(#ot-sdk-cookie-policy-v2.ot-sdk-cookie-policy a) {
		background: transparent;
	}
	:deep(#ot-sdk-cookie-policy-v2.ot-sdk-cookie-policy a:hover) {
		background: transparent;
	}
}
</style>
